import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Links } from "../models";
import { USER_ROLES } from "src/app/app.config";
import { User } from "src/app/user-admin-module/models";
import { AuthService } from "src/app/auth-module/services";
import { AppService } from "./app.service";

const api = "/v1/config";
const routes = {
  getLinks: `${api}/getlinks`,
  setLinks: `${api}/setlinks`,
};

@Injectable({
  providedIn: "root"
})
export class RoutingService {

  constructor(
    private appService: AppService,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService
  ) { }

  routeToInitialView() {
    this.authService.selectUser().subscribe(
      user => {
        if (!user) { return; }

        if (this.appService.returnTo && this.appService.returnTo.length > 1) {
          this.router.navigate([this.appService.returnTo]).then();
          return;
        }

        let initialRoute = "/clearpath/list";
        const userRoles = User.unpackSecurityGroups(user.securityGroups);
        const roleHierarchy = {
          [ USER_ROLES.sys_admin ]: "/settings",
          [ USER_ROLES.sales_manager ]: "/sales-manager/list",
        };

        for (const role in roleHierarchy) {
          if (userRoles.includes(role)) {
            initialRoute = roleHierarchy[ role ];
            break;
          }
        }

        this.router.navigate([initialRoute]);
      });
  }

  getLinks(): Observable<any> {
    return this.http.get(routes.getLinks);
  }

  setLinks(links: Links): Observable<any> {
    return this.http.post(routes.setLinks, links);
  }

}
